/* eslint-disable react/jsx-indent-props */
/* eslint-disable no-undef */
import React, { lazy, Suspense } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import DashboardLayOut from './layouts/Dashboard';
import ErrorLayOut from './layouts/Error';
import { LinearProgress } from '@material-ui/core';
import Error404 from './views/Error404';

const AppRouter = () => {
  return (
    <Router basename={'/'}>
      <Suspense fallback={<LinearProgress />}>
        <Switch>
          {/* <AuthLayOut> */}
          <Route
            component={() => <Redirect to="/auth/login" />}
            exact
            path={`${process.env.PUBLIC_URL}/`}
          />
          <Route
            component={lazy(() => import('views/Login'))}
            exact
            path={`${process.env.PUBLIC_URL}/auth/login`}
          />

          {/* </AuthLayOut> */}

          <DashboardLayOut>
            <PrivateRoute
              component={lazy(() => import('views/BirdView'))}
              exact
              path={`${process.env.PUBLIC_URL}/bird-view`}
            />
            <PrivateRoute
              component={lazy(() => import('views/PickUp'))}
              exact
              path={`${process.env.PUBLIC_URL}/pick-up`}
            />
            <PrivateRoute
              component={lazy(() => import('views/PickUp/PickUpViewOrder'))}
              exact
              path={`${process.env.PUBLIC_URL}/pick-up/view-order`}
            />

            <PrivateRoute
              component={lazy(() => import('views/Dashboard'))}
              exact
              path={`${process.env.PUBLIC_URL}/dashboard`}
            />

            <PrivateRoute
              component={lazy(() => import('views/DashboardDefault'))}
              exact
              path={`${process.env.PUBLIC_URL}/dashboards/default`}
            />
            <PrivateRoute
              component={lazy(() => import('views/OrderManagementList'))}
              exact
              path={`${process.env.PUBLIC_URL}/management/orders`}
            />
            <PrivateRoute
              component={lazy(() => import('views/ViewOrderDetails'))}
              exact
              path={`${process.env.PUBLIC_URL}/management/view/order-details/:id`}
            />
            <PrivateRoute
              component={lazy(() => import('views/CreateOrder'))}
              exact
              path={`${process.env.PUBLIC_URL}/orders/create/new`}
            />
            <PrivateRoute
              component={lazy(() => import('views/ClientManagementList'))}
              exact
              path={`${process.env.PUBLIC_URL}/management/clients`}
            />
            <PrivateRoute
              component={lazy(() => import('views/CustomerManagementList'))}
              exact
              path={`${process.env.PUBLIC_URL}/management/customers`}
            />
            <PrivateRoute
              component={lazy(() => import('views/UserManagementList'))}
              exact
              path={`${process.env.PUBLIC_URL}/management/users`}
            />
            <PrivateRoute
              component={lazy(() => import('views/KanbanBoard'))}
              exact
              path={`${process.env.PUBLIC_URL}/management/badges`}
            />
            <PrivateRoute
              component={lazy(() => import('views/Tracking'))}
              exact
              path={`${process.env.PUBLIC_URL}/management/tracking`}
            />
            <PrivateRoute
              component={lazy(() => import('views/RoutePlanning'))}
              exact
              path={`${process.env.PUBLIC_URL}/management/routePlanning`}
            />
            <PrivateRoute
              component={lazy(() => import('views/RouteMaster'))}
              exact
              path={`${process.env.PUBLIC_URL}/management/RouteMaster`}
            />
            <PrivateRoute
              component={lazy(() => import('views/DeliveryPerformance'))}
              exact
              path={`${process.env.PUBLIC_URL}/management/DeliveryPerformance`}
            />
            <PrivateRoute
              component={lazy(() => import('views/ManifestsList'))}
              exact
              path={`${process.env.PUBLIC_URL}/management/manifests`}
            />
            <PrivateRoute
              component={lazy(() => import('views/CreateManifest'))}
              exact
              path={`${process.env.PUBLIC_URL}/management/manifests/create-new`}
            />
            <PrivateRoute
              component={lazy(() => import('views/ViewManifest'))}
              exact
              path={`${process.env.PUBLIC_URL}/management/manifests/view-details/:mmId`}
            />
            <PrivateRoute
              component={lazy(() => import('views/AuditDashboard'))}
              exact
              path={`${process.env.PUBLIC_URL}/audit/dashboard`}
            />
            <PrivateRoute
              component={lazy(() => import('views/AssignCaptain'))}
              exact
              path={`${process.env.PUBLIC_URL}/assign/lml/captain`}
            />
            <PrivateRoute
              component={lazy(() => import('views/AssignCaptainHomePage'))}
              exact
              path={`${process.env.PUBLIC_URL}/captains/assigned`}
            />
            <PrivateRoute
              component={lazy(() => import('views/FileUpload'))}
              exact
              path={`${process.env.PUBLIC_URL}/upload/file`}
            />

            <Route
              component={lazy(() => import('views/public/Tracking'))}
              exact
              path={`${process.env.PUBLIC_URL}/api/management/tracking/:id`}
            />
          </DashboardLayOut>

          <ErrorLayOut>
            <Route component={Error404} />
          </ErrorLayOut>
        </Switch>
      </Suspense>
    </Router>
  );
};

export default AppRouter;
